
function showLater(){
    
    const later = document.getElementById('later') 
    const now = document.getElementById('now') 
    const laterContainer = document.getElementById('later-container')

    later.addEventListener('click', function(){
     
        laterContainer.classList.remove('hide')
    })

    now.addEventListener('click', function(){
        laterContainer.classList.add('hide')
    })
}
showLater()


// Date picker
$('#date').on('click', function(e) {
    e.preventDefault();
    $(this).attr("autocomplete", "off");  
});

$(document).ready( function() {
    $(function() {
      $("#date").datepicker( {
        minDate: +1,
        maxDate: '+2W',
        dateFormat: 'DD, d MM, yy',
        autoComplete:"off"
      } );
    });
});




//Show relevant time dropdown according to date day selected
$(document).ready(function(){
    $('#date').change(function(){
        
       $("#date-missing-id").addClass('hide')

       let date = $("#date").datepicker('getDate')
       let day = date.getDay()
       switch (day) {
           case 0: day = ".sunday-option"; break;
           case 1: day = ".monday-option"; break;
           case 2: day = ".tuesday-option"; break;
           case 3: day = ".wednesday-option"; break;
           case 4: day = ".thursday-option"; break;
           case 5: day = ".friday-option"; break;
           case 6: day = ".saturday-option"; break;
       }
        $('.delivery-time-select').val("del_time_not_selected");;
        $('.delivery-time-option').addClass('hide');
        $(day).removeClass('hide');
    })
})